import { render, staticRenderFns } from "./DemographyProvincesGrid.vue?vue&type=template&id=52f81b48&"
import script from "./DemographyProvincesGrid.vue?vue&type=script&lang=js&"
export * from "./DemographyProvincesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports